import axios, { AxiosRequestConfig } from "axios";
import { baseUrl } from "./base";

const $http = axios.create({
    baseURL: baseUrl,
});
export const getCookie = (key: string): string => {
    const name = key + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const removeCookie = (key: string) => {
    const d = new Date();
    const domain = 'xdf.cn';
    d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = key + '=; ' + expires + '; domain=' + domain + ';path=/';

};
export const compileStr = (code: string) => {
    let c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for (let i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return escape(c);
};
// 字符串进行解密   
export const uncompileStr = (code: string) => {
    code = unescape(code);
    let c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (let i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
};
export const getImgUrl = async (appid: string, picURL: string) => {



    const defaultconfig: AxiosRequestConfig = {

        withCredentials: true,
    };
    if (picURL) {
        const res = await $http.get(`wxmanager/mp/${appid}/reply/content/pic_url_trans`,
            { params: { url: decodeURIComponent(picURL) }, ...defaultconfig } as AxiosRequestConfig
        )
        return res.data as string
    } else {
        return ''
    }


}

export const toNum = (num: number) => {
    return num < 10 ? `0${num}` : num;
  };